export default __webpack_public_path__ + "static/media/csi_video_inactive.56b364da.svg";